import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Input, Drawer, Button, Grid, Dropdown, Badge, Select, Divider, Typography, List, Popover, message } from 'antd';
import { UserOutlined, SearchOutlined, MenuOutlined, SettingOutlined, DownOutlined, EditOutlined, LoadingOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import companyLogo from '../CompanyLogo.png'; // Import your logo file
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import Notification from '../Notifications/Notification'; // Import the new component
import { responsiveArray } from 'antd/es/_util/responsiveObserver';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat } from '../Components/Constant';
import { useSelector } from 'react-redux';
import eventBus from '../Components/eventBus'; // Import event bus
import { Trophy } from 'lucide-react';

const { Text } = Typography;
const { Header } = Layout;
const { Search } = Input;
const { useBreakpoint } = Grid;
const AppHeader = ({ collapsed, setCollapsed }) => {
  // drawer visibility removed; no local visible state required
  const [notifications, setNotifications] = useState([]);
  const screens = useBreakpoint();
  const navigate = useNavigate(); // Use navigate hook for programmatic navigation
  const location = useLocation();
  const [placeholder, setplaceholder] = useState('search');
  const username = Cookies.get('username') || 'Aptclouds';
  const userId = Cookies.get('userId');
  const [searchResults, setSearchResults] = useState([]); // Stores search results
  const [loading, setLoading] = useState(false); // Loading state
  const [showDropdown, setShowDropdown] = useState(false);
  const [responseToSend, setResponseToSend] = useState([]);
  const [approvalRequests, setApprovalRequests] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [objectApiName, setObjectApiName] = useState('');
  const [recordId, setRecordId] = useState('');
  const [logo, setLogo] = useState("");
  const [environmentLabel, setEnvironmentLabel] = useState('');
  const userImageCookie = Cookies.get('image');
  const security = useSelector((state) => state.data.items[0]);
  const [loadingNotifications, setLoadingNotification] = useState(false);
  const [apps, setApps] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  // App menu search state
  const [appMenuSearch, setAppMenuSearch] = useState("");

  // Make selected app the default for the current user on the backend
  const handleSetSelectedApp = async (app) => {
    if (!app) return;
    try {
      // optimistic UI update
      setSelectedApp(app);

      // Store app ID in cookies for global access
      Cookies.set('selectedAppId', app._id, { expires: 365 }); // expires in 1 year
      Cookies.set('selectedAppName', app.name || app.label, { expires: 365 });
      console.log('userImageCookie in header:', userImageCookie);

      // Call backend to persist default selection
      const apiService = new ApiService(
        `${BASE_URL}/mt_apps/${app._id}/make_default_for_user`,
        { 'Content-Type': 'application/json' },
        'POST',
        {}
      );
      await apiService.makeCall();

      // message.success(`${app.name} set as default`);
      eventBus.emit('AppChanged', { appId: app._id, appName: app.name });
    } catch (err) {
      console.error('Failed to set default app:', err);
      message.error('Failed to set default app');
    }
  };

  const handleAppSelection = (app) => {
    console.log('App selected:', app);
    // navigate according to app name
    if (app.name === 'DiffInsight') {
      navigate('/diffinsight/home');
    } else if (app.name === 'RCAMigration') {
      navigate('/rcamigration/home');
    } else {
      navigate('/Home');
    }

    // persist selection and close the popover
    setTimeout(() => {
      handleSetSelectedApp(app);
      setPopoverVisible(false);
    }, 0);
  };

  const dynamicAppMenuOptions = apps.map((app, index) => ({
    key: `dynamic-${app._id || index}`, // unique key
    label: app.label,
    onClick: () => handleAppSelection(app),
  }));

  const combinedAppMenuOptions = [...dynamicAppMenuOptions];

  // Filtered menu options based on search
  const filteredAppMenuOptions = combinedAppMenuOptions.filter(option =>
    option.label.toLowerCase().includes(appMenuSearch.toLowerCase())
  );

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const apiService = new ApiService(`${BASE_URL}/mt_apps`, { 'Content-Type': 'application/json' }, 'GET');
        const res = await apiService.makeCall();
        const appsData = Array.isArray(res) ? res : [];
        setApps(appsData);
          const defaultSvc = new ApiService(`${BASE_URL}/mt_apps/default_for_user`, { 'Content-Type': 'application/json' }, 'GET');
          const defaultApp = await defaultSvc.makeCall();

          setSelectedApp(defaultApp);
         
          if (defaultApp) {
            // Store default app in cookies when fetched
            Cookies.set('selectedAppId', defaultApp._id, { expires: 365 });
            Cookies.set('selectedAppName', defaultApp.name || defaultApp.label, { expires: 365 });
            eventBus.emit('AppChanged', { appId: defaultApp._id, appName: defaultApp.name });
          }
      } catch (error) {
        console.error('Error fetching apps:', error);
      }
    };

    fetchLogo(); // existing logo fetch
    fetchApps();
  }, []);

  const handleAppClick = (onClick) => {
    onClick();               // Call the app's original onClick
    setPopoverVisible(false); // Close the popover
  };


  const fetchLogo = async () => {
    const orgId = Cookies.get('orgId');
    try {
      const apiService = new ApiService(
        `${BASE_URL}/org_infos/${orgId}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
  
      if (response) {
        if (response.logo) {
          setLogo(response.logo);
        }
  
        // Determine environment label
        let label = '';
        if (response.source_org_id) {
          // Cloned org → Sandbox
          label = response.environment_type || 'SANDBOX';
        } else {
          // Production or main org
          label = response.environment_type || 'PRODUCTION';
        }
        setEnvironmentLabel(label.toUpperCase());
      }
    } catch (error) {
      console.error("Error fetching logo:", error);
    }
  };

  useEffect(() => {

    fetchNotifications();

  }, [])

  const fetchNotifications = async () => {

    try {
      setLoadingNotification(true);
      const apiService = new ApiService(
        `${BASE_URL}/notifications`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      setNotifications(response);
    } catch (error) {
    }
    finally {
      setLoadingNotification(false);
    }

  }


  useEffect(() => {
    checkUrlAndFetchObjectApiName();
  }, [location]);

  const checkUrlAndFetchObjectApiName = () => {
    const url = window.location.href;
    const recordIndex = url.indexOf('/record/');
    if (recordIndex !== -1) {
      const parts = url.substring(recordIndex + 8).split('/');
      const objectApiName = parts[0];
      setObjectApiName(objectApiName);
      setRecordId(parts[1]);
    } else {
      setObjectApiName('');
      setRecordId('');
    }
  };

  // Drawer visibility helpers were removed because drawer is not used here

  const handleMarkAllAsRead = async () => {

    try {
      setLoadingNotification(true);

      const apiService = new ApiService(
        `${BASE_URL}/notifications/mark_all_read`,
        { 'Content-Type': 'application/json' },
        'PATCH'

      );
      await apiService.makeCall();
      fetchNotifications();
    } catch (error) {
    }
    finally {

    }
  };

  

  const handleLogout = () => {
    // Clear cookies
    Cookies.remove('username');
    Cookies.remove('tokenRes');
    Cookies.remove('userId');
    Cookies.remove('orgId');
    Cookies.remove('email');
    Cookies.remove('name');
    Cookies.remove('userCurrency');
    Cookies.remove('timezone');
    Cookies.remove('Locale');
    Cookies.remove('selectedAppId');
    Cookies.remove('selectedAppName');

    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    // Condition 1: If logging out from test environment
    if (hostname === 'test.mind-mesh.com') {
      window.location.href = 'https://test.mind-mesh.com/login';
    }

    // Condition 2: If diffinsight path
    else if (pathname.startsWith('/diffinsight')) {
      window.location.href = 'https://diffinsight.mind-mesh.com';
    }

    // Default condition
    else {
      window.location.href = 'https://nucleus.mind-mesh.com/login';
    }
  };


  const profileMenu = (
  <Menu>
    {/* Conditionally render Profile only if not on diffinsight or rcamigration paths */}
    {!location.pathname.startsWith('/diffinsight') &&
      !location.pathname.startsWith('/rcamigration') && (
        <Menu.Item key="1" onClick={() => navigate('/object-profile')}>
          Profile
        </Menu.Item>
      )}
    {/* Always render Logout */}
    <Menu.Item key="3" onClick={handleLogout}>
      Logout
    </Menu.Item>
  </Menu>
);

  const settingsMenu = (
    <Menu>
      <Menu.Item key="1" icon={<SettingOutlined />} onClick={() => navigate('/setup')}>
        Setup
      </Menu.Item>
      {window.location.href.includes('/record/') && (security?.system_settings?.flexi_page?.create === true) && (
        <Menu.Item key="2" icon={<EditOutlined />} onClick={() => navigate(`/GridLayout/${objectApiName}`, { state: { recordId } })}>
          Edit Page
        </Menu.Item>
      )}
    </Menu>
  );

  const handleMarkAsRead = async (notificationId) => {
    try {
      setLoadingNotification(true);

      const body = {
        "notification": {
          "is_read": true,
        }
      }
      const apiService = new ApiService(
        `${BASE_URL}/notifications/${notificationId}`,
        { 'Content-Type': 'application/json' },
        'PUT',
        body
      );
      await apiService.makeCall();
      fetchNotifications();
    } catch (error) {
    }
    finally {
    }

  };


  const handleSelect = ({ key, item }) => {
    const { objectName } = item.props;
    navigate(`/record/${objectName}/${key}`);
    setShowDropdown(false); // Hide the dropdown after selection
  };

  const fetchSearchResults = async (value) => {
    if (value.length > 2) {
      setSearchKeyword(value);
      if (!value) {
        setSearchResults([]);
        setShowDropdown(false);
        return;
      }

      setLoading(true);
      setShowDropdown(true);

      try {
        const apiService = new ApiService(`${BASE_URL}/global_search/${value}/5`, {
          'Content-Type': 'application/json', // Add any necessary headers, such as content type
        }, 'GET',);
        const response = await apiService.makeCall();
        setResponseToSend(response);

        const formattedResults = [];
        Object.keys(response).forEach((objectName) => {
          const records = response[objectName]?.records || [];
          records.forEach((record) => {
            formattedResults.push({
              label: `${objectName} - ${record.Name || 'Unnamed Record'}`,
              value: record._id,
              objectName, // Include the object name for navigation

            });
          });
        });


        setSearchResults(formattedResults);
      } catch (error) {
        console.error('Error fetching search results:', error);
        setSearchResults([]);
      } finally {
        setLoading(false);
      }
    }

  };
  const menu = (
    <div
      style={{
        maxHeight: '200px', // Limit the height
        overflowY: 'auto',  // Enable vertical scrolling
      }}
    >

      <Menu onClick={handleSelect}>
        {searchResults.map((result) => (
          <Menu.Item key={result.value} objectName={result.objectName}>
            {result.label}
          </Menu.Item>

        ))}
      </Menu>
    </div>
  );
  const handleEnter = async (value) => {
    if (!value) {
      // cleared case -> reset states, don't navigate
      setSearchResults([]);
      setResponseToSend([]);
      setShowDropdown(false);
      return;
    }
    setShowDropdown(false);
    // Navigate to SearchResults with query parameters
    // navigate(`/SearchResults?${queryParams}`);
    navigate('/SearchResults', { state: { searchResults: responseToSend, keyword: searchKeyword } });

  };


  const appMenu = (
    <div style={{ width: 250, padding: 0 }}>
      <Menu style={{ boxShadow: 'none', border: 'none', padding: 0 }}>
        <div style={{ margin: 0, padding: '8px 8px 0 8px' }}>
          <Search
            placeholder="Search apps and items..."
            allowClear
            value={appMenuSearch}
            onChange={e => setAppMenuSearch(e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        {filteredAppMenuOptions.length > 0 ? (
          filteredAppMenuOptions.map(option => (
            <Menu.Item
              key={option.key}
              onClick={() => handleAppClick(option.onClick)}
              style={{ paddingLeft: 16, paddingRight: 16 }}
            >
              {option.label}
            </Menu.Item>
          ))
        ) : (
          <Menu.Item disabled style={{ paddingLeft: 16, paddingRight: 16 }}>
            No apps found
          </Menu.Item>
        )}
      </Menu>
    </div>
  );



  return (

    <Header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 24px",
        // backgroundColor: "#f5f6fa",
        // backgroundColor: "#e7eaf3",
        backgroundColor: "#ffffff",
        borderBottom: "1px solidrgb(245, 246, 249)",
        position: "fixed",
        top: 0,
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
        width: "100%",
        zIndex: 1000,
      }}
    >
      {/* LEFT - Logo + Menu */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: "0 0 auto",
        }}
      >

        {!location.pathname.startsWith('/setup')
          && !location.pathname.startsWith('/diffinsight')
          && !location.pathname.startsWith('/rcamigration')
          && (
            <Button
              icon={<MenuOutlined />}   // three line icon
              onClick={() => {
                eventBus.emit("toggleSidebar");
              }}
              style={{
                marginRight: "16px",
                color: "#374151",
                backgroundColor: "#ffffff",
                border: "1px solid #d1d5db",
              }}
            />
          )}

        {/* {!screens.md && (
          <Button
            icon={<MenuOutlined />}
            onClick={showDrawer}
            style={{
              marginRight: "16px",
              color: "#374151",
              backgroundColor: "#ffffff",
              border: "1px solid #d1d5db",
            }}
          />
        )} */}


        <Popover
          content={appMenu}
          trigger="click"
          placement="bottomLeft"
          overlayStyle={{ padding: 0 }}
          visible={popoverVisible}
          onVisibleChange={setPopoverVisible} // allows click outside to close

        >
          <Button
            icon={<AppstoreOutlined />}
            style={{
              marginRight: "16px",
              color: "#374151",
              backgroundColor: "#ffffff",
              border: "1px solid #d1d5db",
            }}
            onClick={() => setPopoverVisible(!popoverVisible)}

          />
        </Popover>


        <Link
          to="/Home"
          onClick={(e) => {

            e.preventDefault();
            // Prevent default navigation temporarily
            if (security?.app_settings?.CRM?.view === false) {
              message.error('You do not have access to the main application. Please contact your administrator.');
              return;
            }

            if (selectedApp) {
              // Store selected app in cookies when navigating to home
              Cookies.set('selectedAppId', selectedApp._id, { expires: 365 });
              Cookies.set('selectedAppName', selectedApp.name || selectedApp.label, { expires: 365 });
              eventBus.emit('AppChanged', {
                appId: selectedApp._id,
                appName: selectedApp.name,
              });
            } else if (apps.length) {
              const defaultApp = apps.find(app => app.default === true);
              if (defaultApp) {
                // Store default app in cookies
                Cookies.set('selectedAppId', defaultApp._id, { expires: 365 });
                Cookies.set('selectedAppName', defaultApp.name || defaultApp.label, { expires: 365 });
                eventBus.emit('AppChanged', {
                  appId: defaultApp._id,
                  appName: defaultApp.name,
                });
              }
            }

            // After emitting, navigate programmatically to home
            window.location.href = '/';
          }}
        >
          {logo ? (
            <img
              src={logo}
              alt="Company Logo"
              style={{ height: "40px", width: "50px", marginRight: "16px" }}
            />
          ) : (
            <img
              src="/APT-LOGO.png"
              alt="Company Logo"
              style={{ height: "40px", width: "50px", marginRight: "16px" }}
            />
          )}
        </Link>
        {selectedApp?.label && (
          <span
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#111827",
              marginLeft: "8px",
              textTransform: "capitalize",
              letterSpacing: "0.3px",
              display: "inline-flex",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            {selectedApp?.label}
          </span>
        )}




      </div>

      {/* CENTER - Search */}
      {!location.pathname.startsWith('/diffinsight')
        && !location.pathname.startsWith('/rcamigration')
        && (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <Search
              placeholder="Search for records"
              onSearch={handleEnter}
              onChange={(e) => fetchSearchResults(e.target.value)}
              enterButton
              onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              onPressEnter={(e) => e.target.value && handleEnter(e.target.value)} // 👈 Only call if not empty
              allowClear
              style={{ width: "60%", borderRadius: "8px" }}
              suffix={loading ? <LoadingOutlined spin /> : ''}

            />
            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "24px",
                  width: "60%",
                  backgroundColor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  zIndex: 1000,
                  scroll: 'auto',
                }}
              >
                <Dropdown overlay={menu} open={showDropdown}>
                  <div />
                </Dropdown>
              </div>
            )}
          </div>
        )}

      {/* RIGHT - Notifications, Settings, Profile */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: "0 0 auto",
        }}
      >
        {/* Vertical Line */}
        <div
          style={{
            height: "24px",
            width: "1px",
            backgroundColor: "#e5e7eb",
            marginRight: "16px",
          }}
        />
        


        {/* Notifications */}
        {!location.pathname.startsWith('/diffinsight') && !location.pathname.startsWith('/rcamigration') &&(
        <Notification
          notifications={notifications}
          approvalRequests={approvalRequests}
          onMarkAllAsRead={handleMarkAllAsRead}
          onMarkAsRead={handleMarkAsRead}
          loading={loadingNotifications}
        />
        )}

        {/* Settings */}
        {security?.system_settings?.setup_button?.view === true && (
          <Dropdown overlay={settingsMenu} trigger={["click"]}>
            <Button
              icon={<SettingOutlined />}
              style={{
                color: "#374151",
                backgroundColor: "#ffffff",
                border: "1px solid #d1d5db",
                marginRight: "8px",
              }}
            />
          </Dropdown>
        )} 

        {/* Profile */}
        <Dropdown overlay={profileMenu} trigger={["click"]}>
          <Button
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #d1d5db",
              color: "#374151",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar
              // icon={!userImageCookie || userImageCookie === 'undefined' || userImageCookie === null || userImageCookie === '' ? <UserOutlined /> : null}
              icon={<UserOutlined />}

              size="small"
              src={userImageCookie ? `${BASE_URL}/ImageUpload/${Cookies.get('orgId')}/${userImageCookie}.png` : undefined}
              style={{
                color: "#fff",
                marginRight: "8px",
              }}
            />
            {username}
            <DownOutlined style={{ marginLeft: "8px" }} />
          </Button>
        </Dropdown>
        {environmentLabel && environmentLabel !== "PRODUCTION" && (
        <span
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#2563eb", // soft blue tone for non-prod
            border: "1px solid #2563eb33", // subtle border
            backgroundColor: "#2563eb0d", // faint blue background
            borderRadius: "6px",
            padding: "1px 6px",
            marginLeft: "8px",
            textTransform: "uppercase",
            letterSpacing: "0.4px",
            lineHeight: "1",
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
          }}
        >
          {environmentLabel}
        </span>
      )}
      </div>
    </Header>
  );

};

export default AppHeader;